import {
  CheckCircle,
  CheckCircleFill,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Download,
  FileEarmarkPdf,
  PlusCircle,
  TrashFill,
  Upload,
  ZoomIn,
  BellFill
} from '@styled-icons/bootstrap'
import {
  Calendar,
  CommentDetail,
  MessageCheck,
  ShieldQuarter as Brand,
  Trophy,
  Menu
} from '@styled-icons/boxicons-regular'
import { HelpCircle, UserAccount as Accounts } from '@styled-icons/boxicons-solid'
import { AlertCircleOutline } from '@styled-icons/evaicons-outline'
import { ExternalLink, Eye, EyeOff } from '@styled-icons/evaicons-solid'
import { Edit } from '@styled-icons/fa-regular/Edit'
import { Heart, List, MinusCircle, Tag, TrashRestore } from '@styled-icons/fa-solid'
import { Heart as HeartOutline } from '@styled-icons/feather/Heart'
import { Filter, FilterDismiss, Organization as OrganizationChart } from '@styled-icons/fluentui-system-filled'
import { LinkEdit, TextBulletListAdd, TextBulletListSquareEdit } from '@styled-icons/fluentui-system-regular'
import { Cross, FilePicture, Spinner8 } from '@styled-icons/icomoon'
import { ArrowRedo, ArrowUndo, CloseCircle, Reload } from '@styled-icons/ionicons-sharp'
import { ShoppingBag } from '@styled-icons/evaicons-solid'
import { UserTag } from '@styled-icons/fa-solid'
//import { ShoppingBagTag } from '@styled-icons/fluentui-system-filled'
import { ExclamationLg, ExclamationTriangleFill } from '@styled-icons/bootstrap'

import {
  ArrowBackIosNew as ArrowLeft,
  ContentCopy,
  Dashboard,
  Downloading as Load,
  PermMedia as Medias,
  Send,
  Settings
} from '@styled-icons/material'
import { Approval } from '@styled-icons/material-outlined/Approval'
import { Organization } from '@styled-icons/octicons'
import { UserSecret } from '@styled-icons/fa-solid/UserSecret'
import React from 'react'
import { Unpacked } from 'src/types'
import styled, { keyframes } from 'styled-components'

const Spin = keyframes`
from { transform: rotate(0deg);}
to { transform: rotate(360deg);}
`
export const LoadingIcon = styled(Spinner8)`
  width: 1em;
  height: 1em;
  animation: ${Spin} infinite 2s linear;
`
export const icons = [
  { name: 'download', icon: Download },
  { name: 'upload', icon: Upload },
  { name: 'plus-circle', icon: PlusCircle },
  { name: 'minus-circle', icon: MinusCircle },
  { name: 'check-circle-fill', icon: CheckCircleFill },
  { name: 'check-circle', icon: CheckCircle },
  { name: 'check-message', icon: MessageCheck },
  { name: 'alert', icon: AlertCircleOutline },
  { name: 'loading', icon: LoadingIcon }, // 回転するアニメーション付き
  { name: 'filter', icon: Filter },
  { name: 'filter-dismiss', icon: FilterDismiss },
  { name: 'send', icon: Send },
  { name: 'arrow-left', icon: ArrowLeft },
  { name: 'list', icon: List },
  { name: 'content-copy', icon: ContentCopy },
  { name: 'file-picture', icon: FilePicture },
  { name: 'approval', icon: Approval },
  { name: 'arrow-redo', icon: ArrowRedo },
  { name: 'arrow-undo', icon: ArrowUndo },
  { name: 'trash', icon: TrashFill },
  { name: 'trash-restore', icon: TrashRestore },
  { name: 'edit', icon: Edit },
  { name: 'comment', icon: CommentDetail },
  { name: 'list-add', icon: TextBulletListAdd },
  { name: 'list-text-edit', icon: TextBulletListSquareEdit },
  { name: 'eye-off', icon: EyeOff },
  { name: 'eye', icon: Eye },
  { name: 'heart', icon: Heart },
  { name: 'heart-outline', icon: HeartOutline },
  { name: 'reload', icon: Reload },
  { name: 'load', icon: Load },
  { name: 'chevron-right', icon: ChevronRight },
  { name: 'chevron-left', icon: ChevronLeft },
  { name: 'chevron-down', icon: ChevronDown },
  { name: 'tag', icon: Tag },
  { name: 'link-edit', icon: LinkEdit },
  { name: 'cross', icon: Cross },
  { name: 'close', icon: CloseCircle },
  { name: 'external-link', icon: ExternalLink },
  { name: 'pdf', icon: FileEarmarkPdf },
  { name: 'organization', icon: Organization },
  { name: 'dashboard', icon: Dashboard },
  { name: 'accounts', icon: Accounts },
  { name: 'calendar', icon: Calendar },
  { name: 'medias', icon: Medias },
  { name: 'campaign', icon: Trophy },
  { name: 'brand', icon: Brand },
  { name: 'organization-chart', icon: OrganizationChart },
  { name: 'settings', icon: Settings },
  { name: 'help-circle', icon: HelpCircle },
  { name: 'zoom-in', icon: ZoomIn },
  { name: 'user-secret', icon: UserSecret },
  { name: 'bell', icon: BellFill },
  { name: 'menu', icon: Menu },
  { name: 'shopping-bag', icon: ShoppingBag },
  { name: 'user-tag', icon: UserTag },
  { name: 'exclamation', icon: ExclamationLg },
  { name: 'exclamation-triangle-fill', icon: ExclamationTriangleFill }

] as const
const iconNames = icons.map(e => e.name)
export type IconName = Unpacked<typeof iconNames>

type IconProps = {
  /**
   * アイコンの名前
   */
  name: IconName
  /**
   * アイコンの色
   */
  /**
   * サイズは px で指定します。
   */
  size?: string
  /**
   * disabled フラグ
   */
  disabled?: boolean
  /**
   * loading フラグ
   */
  isLoading?: boolean
} & React.ButtonHTMLAttributes<SVGSVGElement>

export const StyledIcon: React.FC<IconProps> = ({ name, isLoading, size = '16px' }) => {
  const StyledIcon = isLoading ? icons.find(n => n.name === 'loading').icon : icons.find(n => n.name === name).icon
  return <StyledIcon style={{ height: size, width: size }} />
}
